import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  sendMessageRequest: ['payload'],
  sendMessageSuccess: ['data'],
  sendMessageFailure: ['error'],
});

export const MessageTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  messageSentResponse: {},
  messageSentError: {},
});

/* Reducers */

const sendMessageRequest = (state) =>
  state.merge({
    ...state,
  });

const sendMessageSuccess = (state, { data = {} }) =>
  state.merge({
    messageSentResponse: data,
    messageSentError: {},
  });

const sendMessageFailure = (state, { error }) =>
  state.merge({
    ...state,
    messageSentResponse: {},
    messageSentError: error,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEND_MESSAGE_REQUEST]: sendMessageRequest,
  [Types.SEND_MESSAGE_SUCCESS]: sendMessageSuccess,
  [Types.SEND_MESSAGE_FAILURE]: sendMessageFailure,
});
